// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".footer-container[data-v-5439c976]{position:relative;background-color:var(--mp-footer);height:auto;padding-bottom:2em}", ""]);
// Exports
module.exports = exports;
